import React, { Component, useState } from 'react';
import { Box,
    HStack, 
    Stack, 
    Checkbox, 
    Input, 
    Text, 
    Textarea,
    Select,
    Divider,
    Fade,
    Button,
    Icon,
    Flex,
    extendTheme } from '@chakra-ui/react';
import '@fontsource/playfair-display/400.css';
import '@fontsource/source-sans-pro/600.css';

const bodyFont = "'Playfair Display', serif"; 
const headerFont = "'Source Sans Pro', sans-serif";

const render = (rate) => {
    if (rate.toString().length > 0) {
        return(
            <Text
                fontFamily={bodyFont}
                fontSize={'1vw'}
                color={'beige.500'}
                >
                {rate}
            </Text>
        );
    }
    return;
}

export default function RatesSection(props){
    const rates = props.rates;
    const includeRates = props.includeRates;

    if(!includeRates){
        return;
    } 

    return(
        <Stack
            w={'7vw'}
            h={'20vw'}
            alignContent={'center'}
            justifyContent={'center'}
            display={'flex'}
            spacing={'1vw'}
            bgColor={'beige.150'}
            >
            <Text 
                fontFamily={headerFont} 
                fontSize={'1.5vw'}
                color={'beige.400'}
                textTransform={'uppercase'}
                > 
                Rates
            </Text>
            {render(rates.rate1)}
            {render(rates.rate2)}
            {render(rates.rate3)}
            {render(rates.rate4)}
            {render(rates.rate5)}
        </Stack>
    )
}